export default {
	// defaultErrorMessage: 'Network anomaly, please refresh the page or try your operation again!<br>If this error message continues to appear, please contact IT for help.',
	defaultErrorMessage: '网络异常，请重新刷新页面或者重新操作！<br>若问题再次出现，请联系技术人员。',
	callbackFetch: null, //发出后的回调
	callback401: null,   //401响应的回调
	callbackDone: null,  //返回立即回调
	callbackError: null, //错误响应回调
	callbackSuccess: null, //ajax成功返回执行的方法

	_fetch: function(url, method, data, opt) {
		var options = {
	        url: url,
			type: method,
			cache: false
	    }
	    if(method.toLowerCase() === "get") {
			if(data) {
				url += '?' + $.param(data);
				options.url = url;
			}
		}
		else if(opt && opt.contentType !== undefined) {
			opt.contentType && (options.headers = { "Content-Type": opt.contentType });
			options.data = data;
			options.contentType = false;
			options.processData = false;
		}
		else {
			options.headers = { "Content-Type": 'application/json' };
			options.data = JSON.stringify(data);
		}

		if(opt && opt.button) {
			hz.tools.form.loadingButton(opt.button);
		}

		var netWorkTips = this.defaultErrorMessage;
		let callbackFetch = this.callbackFetch;
		let callback401 = this.callback401;
		let callbackDone = this.callbackDone;
		let callbackError = this.callbackError;
		let callbackSuccess = this.callbackSuccess;


        return new Promise(function(resolve, reject) {
            options.success = function(data, textStatus, xhr) {
				if(callbackSuccess && !callbackSuccess(data)){
					return ;
				}
            	callbackDone && callbackDone(handler);
            	hz.tools.form.resetButton(opt && opt.button);
            	if(xhr.status === 204) {
					return resolve();
				}
				//正常情况-----
				if(xhr.status.toString().slice(0, 1) === "2" || xhr.status === 304) {
					if(method === 'delete') {
						return resolve(data);
					}
				}
				//处理封装的返回数据 ----
				if(data.errorCode !== undefined) {
					if(data.errorCode) {
						// var tips = hz.dialog.error('Error', data.errorMessage || '服务器错误');
						// var tips = hz.dialog.tips("系统异常。", -1, 'error');
			        	let err = {
			        		// tips: tips,
			        		xhr: xhr,
			        		detail: data
			        	};
			        	reject(err);
					}
					else {
						resolve(data.data);
					}
				}
				else { //成功的处理 ---
					resolve(data);
				}
				
            }
            options.error = function(xhr, textStatus, statusText) {
            	hz.tools.form.resetButton(opt && opt.button);
            	callbackDone && callbackDone(handler);
            	
            	if(textStatus === 'abort') {
            		return;
            	}
            	
            	if(xhr.status === 401 && callback401) { //未登录
					callback401 && callback401(handler, xhr);
					
					return;
				}
				
            	var err = xhr.responseJSON;

            	var tipsMessage = { title: 'Error', msg: '' };

            	if(callbackError) {
            		tipsMessage = callbackError(handler, xhr);
            	}
            	else if(err && typeof err === 'object') {
            		tipsMessage = { title: 'Error', msg: err.errorMessage };
            	}
            	
            	if(!tipsMessage) {
            		tipsMessage = { };
            	}
            	if(!tipsMessage.title) {
            		tipsMessage.title = 'Error';
            	}
            	
            	if(!tipsMessage.msg) {
            		tipsMessage.msg = xhr.responseText? xhr.responseText.slice(0, 500): netWorkTips;
            	}
            	
	        	// var tips = hz.dialog.tips("系统异常。", -1, 'error');
	        	!err && (err = {})
	        	// err.tips = tips;
	        	err.xhr = xhr;
	        	err.detail = tipsMessage;
	        	reject(err);
            }
            
	    	var handler = $.ajax(options);
	    	callbackFetch && callbackFetch(handler, opt);
        })
	},
	
	post: function(url, data, opt) {
		return this._fetch(url, 'post', data, opt);
	},

	put: function(url, data, opt) {
		return this._fetch(url, 'put', data, opt);
	},

	get: function(url, data, opt) {
		return this._fetch(url, 'get', data, opt);
	},
	
	delete: function(url, opt) {
		return this._fetch(url, 'delete', null, opt);
	}
}      


// WEBPACK FOOTER //
// ./src/js/ajax.js